import { Box, Paper, Typography, Alert } from "@material-ui/core";
import PropTypes from "prop-types";
import { BRAND } from "src/theme/brandTokens";

/**
 * Envoltorio visual de sección: Paper outlined + header numerado + Alert de
 * faltantes blandas (no bloquea guardado, solo informa).
 * Expone un id ancla para scroll-spy / scrollIntoView desde el nav.
 */
const SeccionWrapper = ({ id, numero, titulo, faltantes, children }) => (
  <Paper
    variant="outlined"
    id={id}
    // El scroll ahora vive en el Box interno de EditarPropuestaV2; el top 0
    // del contenedor ya está al ras del TopBar, así que basta un margen mínimo.
    sx={{ p: 3, mb: 3, scrollMarginTop: 16 }}
  >
    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 3 }}>
      <Box
        sx={{
          width: 32,
          height: 32,
          borderRadius: "50%",
          bgcolor: BRAND.color.primary,
          color: "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: 14,
          fontWeight: 700,
        }}
      >
        {numero}
      </Box>
      <Typography
        variant="h6"
        sx={{ color: BRAND.color.primary, fontWeight: 700 }}
      >
        {titulo}
      </Typography>
    </Box>
    {faltantes && faltantes.length > 0 && (
      <Alert severity="warning" sx={{ mb: 2 }}>
        Faltan datos para enviar: {faltantes.join(" · ")}. Puedes guardar el
        BORRADOR igualmente.
      </Alert>
    )}
    {children}
  </Paper>
);

SeccionWrapper.propTypes = {
  id: PropTypes.string.isRequired,
  numero: PropTypes.number.isRequired,
  titulo: PropTypes.string.isRequired,
  faltantes: PropTypes.arrayOf(PropTypes.string),
  children: PropTypes.node.isRequired,
};

SeccionWrapper.defaultProps = { faltantes: undefined };

export default SeccionWrapper;
